/**
 * İçe aktarılamayan satırları geliştirmeye gönderme (kullanıcı kararı
 * 25.10.2026). Metin `lib/geriBildirim.ts`te kurulur; kelime seçimi ekstre
 * biçimi kartındakiyle aynı (aç / kapat). Tutarlar ve tarihler rakam olduğu
 * için hiç açılmaz.
 */

import { useMemo, useState } from "react";
import { M } from "../dil";
import { kelimeAcikMi, type KelimeSayimi } from "../lib/ekstreMaske";
import {
  GERI_BILDIRIM_SATIR_SINIRI,
  satirKelimeleri,
  satirMetni,
  type GeriBildirimIstegi,
  type GeriBildirimSatiri,
} from "../lib/geriBildirim";
import { KelimeListesi, secimOf } from "./EkstreMaskeKarti";
import { GeriBildirimKarti } from "./GeriBildirimKarti";

export function SatirGeriBildirimi({
  bicimAdi,
  satirlar,
  istek,
}: {
  readonly bicimAdi: string;
  readonly satirlar: readonly GeriBildirimSatiri[];
  readonly istek?: GeriBildirimIstegi | null;
}) {
  const [degisen, setDegisen] = useState<ReadonlyMap<string, boolean>>(new Map());
  const secim = useMemo(() => secimOf(degisen), [degisen]);
  const kelimeler = useMemo(() => satirKelimeleri(satirlar), [satirlar]);
  const metin = useMemo(() => satirMetni(bicimAdi, satirlar, secim), [bicimAdi, satirlar, secim]);
  const acik = kelimeler.filter((k) => kelimeAcikMi(k.yazilis, secim));
  const kapali = kelimeler.filter((k) => !kelimeAcikMi(k.yazilis, secim));

  const degistir = (k: KelimeSayimi, ac: boolean): void => {
    setDegisen((m) => {
      const yeni = new Map(m);
      if (ac === k.varsayilanAcik) yeni.delete(k.anahtar);
      else yeni.set(k.anahtar, ac);
      return yeni;
    });
  };

  return (
    <GeriBildirimKarti kaynak="ice-aktarma" metin={metin} {...(istek === undefined ? {} : { istek })}>
      {satirlar.length > GERI_BILDIRIM_SATIR_SINIRI && (
        <p className="text-[12px] text-muted">{M.iceAktar.geriBildirim.satirSiniri(GERI_BILDIRIM_SATIR_SINIRI)}</p>
      )}
      <p className="text-[12px] text-muted">
        {M.iceAktar.geriBildirim.kelimeIpucu}
      </p>
      <KelimeListesi baslik={M.iceAktar.maske.acikKelimeler} kelimeler={acik} acik onDegistir={(k) => degistir(k, false)} />
      <KelimeListesi baslik={M.iceAktar.maske.kapaliKelimeler} kelimeler={kapali} acik={false} onDegistir={(k) => degistir(k, true)} />
    </GeriBildirimKarti>
  );
}
